import { get, keys } from 'lodash';

import { Action } from '../../actions';
import {
    UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID,
    UpdateBannerCpcVideoCreativeId
} from '../../actions/video';
import {
    EditBannersState,
    getEditedBannerWithVideo,
    MassActionId
} from '../../typings/bannersEditState';
import { ValidationErrorsData } from '../../typings/common';
import { State } from '../../typings/state';
import { EditBannersInitialState } from '../bannersEdit';

const updateBannerVideoCpcCreativeId = (
    state: EditBannersState,
    action: UpdateBannerCpcVideoCreativeId,
    fullState: State
): EditBannersState => {
    const banner = getEditedBannerWithVideo(
        fullState.editBanners.banners[action.id]
    );
    if (!banner) {
        return state;
    }

    const oldErrors = get(banner, 'errors', {});
    const newErrors = keys(oldErrors)
        .filter(key => key !== 'creativeId')
        .reduce(
            (acc: ValidationErrorsData, errorKey: string) => ({
                ...acc,
                [errorKey]: get(oldErrors, errorKey, [])
            }),
            {} as ValidationErrorsData
        );

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.id]: {
                ...banner,
                errors: newErrors
            }
        }
    };
};

export function videoReducer(
    state: EditBannersState = EditBannersInitialState,
    action: Action,
    fullState: State
): EditBannersState {
    switch (action.type) {
        case UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID:
            return action.id === MassActionId.bannersEdit
                ? state
                : updateBannerVideoCpcCreativeId(state, action, fullState);
        default:
            return state;
    }
}
